module.exports = __webpack_public_path__ + "img/11d.3df81688.png";